// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__32CIR","insightsList":"newBusinessInsightsMenu_insightsList__2IHKJ","active":"newBusinessInsightsMenu_active__F63l6"};